import { generateKeys, generateLocalization } from '../utils';
export const assetCategories = generateLocalization('assetCategories', generateKeys({
    forexMini: {
        label: 'Forex',
        securities: [
            'Forex',
            'Metals',
            'EU_Symbols',
        ],
        localization: { id: '', defaultMessage: '' },
    },
    cryptoMini: {
        label: 'Crypto',
        securities: [
            'Cryptos 24/7 I',
            'Cryptos 24/7 II',
            'Cryptos 24/5',
        ],
        disabledIn: ['cn'],
        localization: { id: '', defaultMessage: '' },
    },
}));
